<form [formGroup]="form">
    <mat-radio-group color="primary" [formControlName]="inputName">
        <mat-radio-button *ngFor="let obj of objArray" [value]="obj.value">{{obj.display}}</mat-radio-button>
    </mat-radio-group>
</form>

